import { FC, useState } from 'react';
import { Form } from 'antd';
import { Button, ButtonProps } from '@base/lib/Button';
import { FormEmail } from '@base/snippets/FormEmail';
import { trackLead } from 'base/utils/tracker';
import { Message } from '@base/lib/Message';
import { postSubscribe } from 'mod/subscribe/service';
import { useTrans } from 'base/utils/i18n';
import { useStoreState } from 'base/store'

export type ISubscribeFormProps = {
    className?: string;
    moduleId?: string;
    btnProps?: ButtonProps;
    onSuccess?: () => void;
}

export const SubscribeForm: FC<ISubscribeFormProps> = props => {
    const {
        className,
        moduleId = 'default',
        btnProps = {},
        onSuccess
    } = props;

    const rootState = useStoreState('rootStore');

    const [loading, setLoading] = useState<boolean>(false);
    const { children: btnText, ...restBtnProps } = btnProps;
    const { t } = useTrans();

    const onSubmit = async ({ email }: { email: string }) => {
        setLoading(true);
        try {
            await postSubscribe({
                email,
                type: rootState?.pageCode || '',
            })
            trackLead({
                name: moduleId,
                info: email,
            })
            onSuccess?.();
        } catch (e) {
            Message.error(e.message);
        }
        setLoading(false);
    };

    return (
        <Form className={className} layout="inline" onFinish={onSubmit}>
            <FormEmail
                label={false}
                showLabel={false}
                inputProps={{
                    className: 'g-email',
                    placeholder: t('web_subscribe_email_placeholder'),
                    autoComplete: 'xxx',
                }}
            />
            <Button
                className="g-btn-submit"
                htmlType="submit"
                loading={loading}
                type={'base'}
                {...restBtnProps}
            >
                {btnText || t('web_subscribe_btn_subscribe')}
            </Button>
        </Form>
    )
};